module.exports = __webpack_public_path__ + "assets/img/slat_close.ba54d549.svg";